import IconContainer from "./IconContainer"
import { IconProps } from "./IconUtilities"

const IconInput: React.FC<IconProps> = ({ className, size, contained }) => {
	if (contained) {
		return (
			<IconContainer
				className={className}
				size={size}
			>
				<path d="M13.6364 1.37061H1.36364C0.613636 1.37061 0 1.98424 0 2.73424V5.4547H1.36364V2.72061H13.6364V12.2865H1.36364V9.54561H0V12.2797C0 13.0297 0.613636 13.6297 1.36364 13.6297H13.6364C14.3864 13.6297 15 13.0297 15 12.2797V2.73424C15 1.97742 14.3864 1.37061 13.6364 1.37061V1.37061ZM6.81818 10.2274L9.54545 7.50015L6.81818 4.77288V6.81833H0V8.18197H6.81818V10.2274Z" />
			</IconContainer>
		)
	}
	return (
		<path d="M13.6364 1.37061H1.36364C0.613636 1.37061 0 1.98424 0 2.73424V5.4547H1.36364V2.72061H13.6364V12.2865H1.36364V9.54561H0V12.2797C0 13.0297 0.613636 13.6297 1.36364 13.6297H13.6364C14.3864 13.6297 15 13.0297 15 12.2797V2.73424C15 1.97742 14.3864 1.37061 13.6364 1.37061V1.37061ZM6.81818 10.2274L9.54545 7.50015L6.81818 4.77288V6.81833H0V8.18197H6.81818V10.2274Z" />
	)
}

export default IconInput
